export default __webpack_public_path__ + "static/media/tieuhao.7a69b773.png";